import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Popup as DXPopup} from 'devextreme-react';


export default class Popup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.visible,
        };

        this.onShowing = this.onShowing.bind(this);
        this.onHiding = this.onHiding.bind(this);

        // this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            visible: props.visible,
        });
    }

    // closeOnOutsideClick(e) {
    //     e;
    //     // console.log('closeOnOutsideClick')
    //     this.setState({visible: false});
    //     const {setProps} = this.props;
    //     if (setProps) {
    //         setProps({
    //             visible: false,
    //         });
    //     }
    //     return true;
    // }

    onShowing(e) {
        // console.log('onShowing')
        this.setState({visible: true});
        const {setProps} = this.props;
        if (setProps) {
            setProps({
                visible: true,
                showing: {
                    timestamp: Date.now()
                },
            });
        }
    }

    onHiding(e) {
        // console.log('onHiding')
        this.setState({visible: false});
        const {setProps} = this.props;
        if (setProps) {
            setProps({
                visible: false,
                hiding: {
                    timestamp: Date.now()
                },
            });
        }
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return <DXPopup
            {...omit(['loading_state', 'setProps'], this.props)}
            {...dataAttributes}
            onShowing={this.props.onShowing || this.onShowing}
            onHiding={this.props.onHiding || this.onHiding}
            visible={this.state.visible}

            // children={this.props.children}
            // showTitle={this.props.showTitle}
            // title={this.props.title}
            // visible={this.state.visible}
            // dragEnabled={this.props.dragEnabled}
            // closeOnOutsideClick={this.props.closeOnOutsideClick && this.closeOnOutsideClick}
            // closeOnOutsideClick={false}
        />
    }
}

Popup.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Configures UI component visibility animations. This object contains two fields: show and hide.
     */
    animation: PropTypes.object,
    /**
     * Specifies whether to close the UI component if a user clicks outside it
     */
    closeOnOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    /**
     * Specifies the container in which to render the UI component
     */
    container: PropTypes.string,
    /**
     * An alias for the contentTemplate property specified in React. Accepts a custom component
     */
    contentComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the contentTemplate property specified in React. Accepts a rendering function.
     */
    contentRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for the UI component content
     */
    contentTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies whether to render the UI component's content when it is displayed. If false, the content is rendered immediately.
     */
    deferRendering: PropTypes.bool,
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies whether or not to allow a user to drag the popup window
     */
    dragEnabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Specifies whether to display the Popup in full-screen mode
     */
    fullScreen: PropTypes.bool,
    /**
     * Specifies the UI component's height in pixels
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Dash event
     */
    hiding: PropTypes.object,
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Specifies the maximum height the UI component can reach while resizing
     */
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the maximum width the UI component can reach while resizing
     */
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the minimum height the UI component can reach while resizing
     */
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the minimum width the UI component can reach while resizing
     */
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function that is executed after the UI component is hidden
     */
    onHidden: PropTypes.func,
    /**
     * A function that is executed before the UI component is hidden
     */
    onHiding: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed each time the UI component is resized by one pixel
     */
    onResize: PropTypes.func,
    /**
     * A function that is executed when resizing ends
     */
    onResizeEnd: PropTypes.func,
    /**
     * A function that is executed when resizing starts
     */
    onResizeStart: PropTypes.func,
    /**
     * A function that is executed before the UI component is displayed
     */
    onShowing: PropTypes.func,
    /**
     * A function that is executed after the UI component is displayed
     */
    onShown: PropTypes.func,
    /**
     * A function that is executed when the UI component's title is rendered
     */
    onTitleRendered: PropTypes.func,
    /**
     * Positions the UI component
     */
    position: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'left', 'left bottom', 'left top', 'right', 'right bottom', 'right top', 'top']), PropTypes.object]),
    /**
     * Specifies whether or not an end user can resize the UI component
     */
    resizeEnabled: PropTypes.bool,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Specifies whether to shade the background when the UI component is active
     */
    shading: PropTypes.bool,
    /**
     * Specifies the shading color. Applies only if shading is enabled
     */
    shadingColor: PropTypes.string,
    /**
     * Specifies whether or not the UI component displays the Close button
     */
    showCloseButton: PropTypes.bool,
    /**
     * A Boolean value specifying whether or not to display the title in the popup window
     */
    showTitle: PropTypes.bool,
    /**
     * Dash event
     */
    showing: PropTypes.object,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * The title in the overlay window
     */
    title: PropTypes.string,
    /**
     * An alias for the titleTemplate property specified in React. Accepts a custom component.
     */
    titleComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the titleTemplate property specified in React. Accepts a rendering function.
     */
    titleRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for the UI component title. Does not apply if the title is defined.
     */
    titleTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
    /**
     * Configures toolbar items
     */
    toolbarItems: PropTypes.arrayOf(PropTypes.object),
    /**
     * A Boolean value specifying whether or not the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width in pixels
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

Popup.defaultProps = {
    accessKey: null,
    animation: null,
    closeOnOutsideClick: false,
    // container: undefined,
    // contentTemplate: 'content',
    deferRendering: true,
    disabled: false,
    dragEnabled: false,
    elementAttr: {},
    focusStateEnabled: true,
    fullScreen: false,
    height: 'auto',
    // hint: undefined,
    hoverStateEnabled: false,
    maxHeight: null,
    maxWidth: null,
    minHeight: null,
    minWidth: null,
    onContentReady: null,
    onDisposing: null,
    onHidden: null,
    onHiding: null,
    onInitialized: null,
    onOptionChanged: null,
    onResize: null,
    onResizeEnd: null,
    onResizeStart: null,
    onShowing: null,
    onShown: null,
    // position: {my: 'center', at: 'center', of: window},
    resizeEnabled: false,
    rtlEnabled: false,
    shading: true,
    shadingColor: '',
    showCloseButton: false, // true (desktop)
    showTitle: true,
    tabIndex: 0,
    title: '',
    titleTemplate: 'title',
    // toolbarItems
    visible: false,
    width: 'auto'
};
